import $ from 'jquery';
import { createRoot } from 'react-dom/client';
import { useEffect, useState, useRef } from 'react';

const LoadMore = props => {
	const [cards, setCards] = useState([]);
	const [showButton, setShowButton] = useState(true);
	const [infiniteScroll, setInfiniteScroll] = useState(false);

	const currentPage = useRef(2);

	useEffect(() => {
		if (!infiniteScroll) {
			return;
		}

		let wait = false;

		const handleScroll = async () => {
			const percentage = ($(window).scrollTop() + $(window).height()) * 100 / $(document).height();

			if (percentage > 50 && !wait) {
				wait = true;
				setCards(await getCards(currentPage.current++));
				wait = false;
			}
		};

		window.addEventListener('scroll', handleScroll);

		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, [infiniteScroll]);

	useEffect(() => {
		if (!cards.length) {
			return;
		}

		const ul = document.querySelector('ul.Card-wrapper');
		ul.append(...cards);

		ul.dispatchEvent(new CustomEvent('load-more:append', {
			detail: cards
		}));
	}, [cards]);

	const handleClick = () => {
		setShowButton(false);
		setInfiniteScroll(true);

		const loadMoreCards = async () => {
			setCards(await getCards(currentPage.current++));
		};

		loadMoreCards();
	};

	return (
		<a className={`Cards-button${showButton ? '-visible' : '-hidden'} Cards-button Button Button-load-more`} onClick={handleClick}>
			{props.text}
		</a>
	);
};

async function getCards(page) {
	return new Promise((resolve, reject) => {
		$.ajax({
			method: 'GET',
			url: '?query-0-page=' + page,
			success: data => {
				const parser = new DOMParser();
				const html = parser.parseFromString(data, 'text/html');

				const cards = html.querySelectorAll('ul li.scholarship');

				resolve(cards);
			},
			error: reject
		});
	});
}

const container = document.getElementById('LoadMore');

if (container) {
	const root = createRoot(container);
	root.render(<LoadMore text={container.textContent || 'Ver mais'} />);
}
